import { Navigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  requireRole?: 'manager';
}

export function PrivateRoute({ children, requireRole }: Props) {
  const { user, token } = useAuth();
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }
  if (requireRole === 'manager' && user.role !== 'manager') {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
